import questionnaire from "./questionnaire/reducer";
import questionnaireViewUpdate from "./questionnaireViewUpdate/reducer";
import providers from "./providers/reducer";
import schedule from "./schedule/reducer";
import callReports from "./callReports/reducer";
import callTakers from "./callTakers/reducer";
import textBlasts from "./textBlasts/reducer";
import returnCalls from "./returnCall/reducer";
import briefings from "./briefings/reducer";
import lessons from "./lessons/reducer";
import recognitions from "./recognitions/reducer";

export default {
  questionnaire,
  questionnaireViewUpdate,
  providers,
  schedule,
  callReports,
  callTakers,
  textBlasts,
  returnCalls,
  briefings,
  lessons,
  recognitions,
};
